import {
    FeatureFlagAdminApi,
    FeatureFlagAdminController$FeatureFlagJson,
    FeatureFlagAdminController$FeatureFlagUpdateJson
} from "../api/generated/featureflags-rest";
import ApiConfig from "../api/config/api-config";
import {ListResult} from "../api/generated/lib-rest";

const items = <T>(result: Promise<ListResult<T>>): Promise<T[]> => result.then(x => x.items);

// Client-only feature flag service (original behavior)
export interface IFeatureFlagService {
    isEnabled(featureFlag: string): boolean;
}

class FeatureFlagServiceImpl implements IFeatureFlagService {

    private _featureFlags: {[key: string]: boolean} = {
        EVENT_LIST: false,
        ADMIN_AREA: true
    };

    isEnabled(featureFlag: string): boolean {
        return this._featureFlags[featureFlag];
    }
}

export const FeatureFlagService: IFeatureFlagService = new FeatureFlagServiceImpl();

// Admin feature flag service for the admin management page
export interface IFeatureFlagAdminService {
    list(): Promise<FeatureFlagAdminController$FeatureFlagJson[]>;
    update(key: string, value: FeatureFlagAdminController$FeatureFlagUpdateJson["value"]): Promise<void>;
    reset(key: string): Promise<void>;
}

class FeatureFlagAdminServiceImpl implements IFeatureFlagAdminService {

    constructor(private readonly _api: FeatureFlagAdminApi) {
    }

    async list(): Promise<FeatureFlagAdminController$FeatureFlagJson[]> {
        return (await items(this._api.list()))
            .sort((a, b) => a.key.localeCompare(b.key));
    }

    async update(key: string, value: FeatureFlagAdminController$FeatureFlagUpdateJson["value"]): Promise<void> {
        await this._api.update(key, { value });
    }

    async reset(key: string): Promise<void> {
        await this._api.delete(key);
    }
}

export const FeatureFlagAdminService: IFeatureFlagAdminService = new FeatureFlagAdminServiceImpl(
    new FeatureFlagAdminApi(new ApiConfig()));
